export function VehicleVisualsCtrl ($state, $scope, $window, $uibModal, $translate, messages, sessionObjAPI, workshopAPI, settings) {
  $scope.settings = settings;

  $scope.disable = function () {
    $scope.settings.vehicle_visuals_api_key  = null;
    $scope.settings.vehicle_visuals_password = null;
    $scope.settings.vehicle_visuals_user     = null;

    workshopAPI.patch('/company', $scope.settings, 'company')
    .then(function () {
      return sessionObjAPI.refresh();
    }).then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.save = function () {
    workshopAPI.patch('/company', $scope.settings, 'company')
    .then(function () {
      return sessionObjAPI.refresh();
    }).then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.upgrade = function () {
    //$uibModalInstance.close();
    workshopAPI.get('/vehicle_visuals/subscribe_url').then(function (url) {
      $window.open(url, '_blank');
    }, function (err) {
      messages.error(err);
    });
  };
}
